<template>
  <div class="home-page">
    <!-- Hero Banner Section -->
    <section class="page-banner bgs-cover overlay ban-color" :style="{ backgroundImage: 'url(/assets/images/banner11.jpg)' }">
      <!-- Spanish Display -->
      <div class="container display-anime disp_es" v-if="$i18n.locale === 'es'">
        <div class="banner-inner">
          <h1 class="page-title-home">
            {{ $t('home.hero.empoweringBusinesses') }} <br>{{ $t('home.hero.with') }}
            <span id="flip-text" class="bg-l-white py-5">
              <div id="flip">
                <div>
                  <div>{{ $t('home.hero.bespoke') }}</div>
                </div>
                <div>
                  <div>{{ $t('home.hero.curated') }}</div>
                </div>
                <div>
                  <div>{{ $t('home.hero.tailored') }}</div>
                </div>
              </div>
            </span>
            {{ $t('home.hero.solutions') }}
          </h1>
        </div>
        <div class="sml-text">
          <p>
            {{ $t('home.hero.tagline.part1') }}<br> 
            {{ $t('home.hero.tagline.part2') }}
            <span> {{ $t('home.hero.tagline.highlight') }}<br> 
            {{ $t('home.hero.tagline.part3') }}</span>
          </p>
        </div>
      </div>

      <!-- English Display with Animation -->
      <div class="container display-anime disp_en" v-if="$i18n.locale === 'en'">
        <div class="banner-inner">
          <h1 class="page-title-home">
            {{ $t('home.hero.empoweringBusinesses') }} <br>{{ $t('home.hero.with') }}
            <span id="flip-text" class="bg-l-white py-5">
              <div id="flip">
                <div>
                  <div>{{ $t('home.hero.bespoke') }}</div>
                </div>
                <div>
                  <div>{{ $t('home.hero.curated') }}</div>
                </div>
                <div>
                  <div>{{ $t('home.hero.tailored') }}</div>
                </div>
              </div>
            </span>
            {{ $t('home.hero.solutions') }}
          </h1>
        </div>
        <div class="sml-text">
          <p>
            {{ $t('home.hero.tagline.part1') }}<br> 
            {{ $t('home.hero.tagline.part2') }}
            <span> {{ $t('home.hero.tagline.highlight') }}<br> 
            {{ $t('home.hero.tagline.part3') }}</span>
          </p>
        </div>
      </div>

      <!-- Mobile Display -->
      <div class="container display-anime1">
        <div class="banner-inner">
          <h1 class="page-title-home">
            {{ $t('home.hero.empoweringBusinesses') }} {{ $t('home.hero.with') }} <br>
            <span id="flip-text" class="bg-l-white">
              <div id="flip">
                <div>
                  <div>{{ $t('home.hero.bespoke') }}</div>
                </div>
                <div>
                  <div>{{ $t('home.hero.curated') }}</div>
                </div>
                <div>
                  <div>{{ $t('home.hero.tailored') }}</div>
                </div>
              </div>
            </span><br>
            {{ $t('home.hero.solutions') }}
          </h1>
        </div>
        <div class="sml-text">
          <p>
            {{ $t('home.hero.tagline.part1') }}<br> 
            {{ $t('home.hero.tagline.part2') }}
            <span> {{ $t('home.hero.tagline.highlight') }}<br> 
            {{ $t('home.hero.tagline.part3') }}</span>
          </p>
        </div>
      </div>
    </section>

    <!-- Services Description Section -->
    <section class="mar-ser">
      <div class="container ser-des">
        <p>
          {{ $t('home.services.description.part1') }}
          <span>{{ $t('home.services.description.highlight') }}</span>
          {{ $t('home.services.description.part2') }}
        </p>
        <h1 class="mt-50">
          {{ $t('home.services.focus.part1') }}
          <span>{{ $t('home.services.focus.highlight') }}</span>
        </h1>
      </div>
    </section>

    <!-- Services Cards Section -->
    <section class="about-section style-five py-80 rpy-20 bgn-blk p-tb">
      <div class="container2 pad-r-0">
        <div class="scrollmenu col-md-12 pd-0 d-flex about-content justify-content-between">
          <!-- Banking and Enterprise Card -->
          <div class="feature-item feat1 wrap-card abs3" style="">
            <img class="card-img-scroll" src="/assets/images/about/bank.jpg">
            <div class="feature-content">
              <h5 class="feat-bold">{{ $t('home.cards.banking.title') }}</h5>
              <p class="lh1">{{ $t('home.cards.banking.description') }}</p>
            </div>
            <button class="theme-btn2" @click.stop="expandCard('banking')">{{ $t('home.cards.expand') }}<img src="/assets/images/icon/next.png"></button>

           
          </div>

          <!-- Digital Services Card -->
          <div class="feature-item feat1 wrap-card abs3" style="">
            <img class="card-img-scroll" src="/assets/images/about/digital.png">
            <div class="feature-content">
              <h5 class="feat-bold">{{ $t('home.cards.digital.title') }}</h5>
              <p class="lh1">{{ $t('home.cards.digital.description') }}</p>
            </div>
            <button class="theme-btn2" @click.stop="expandCard('digital')">{{ $t('home.cards.expand') }}<img src="/assets/images/icon/next.png"></button>

            
          </div>

          <!-- IT Staffing Card -->
          <div class="feature-item feat1 wrap-card abs3" style="">
            <img class="card-img-scroll" src="/assets/images/about/it-staff.jpg">
            <div class="feature-content">
              <h5 class="feat-bold">{{ $t('home.cards.itStaffing.title') }}</h5>
              <p class="lh1">{{ $t('home.cards.itStaffing.description') }}</p>
            </div>
            <button class="theme-btn2" @click.stop="expandCard('itStaffing')">{{ $t('home.cards.expand') }}<img src="/assets/images/icon/next.png"></button>

            
          </div>

          <!-- Contact Card -->
          <div class="feature-item feat1 wrap-card abs3 bg-b mr-it">
            <div class="feature-content">
              <p class="lh1 staff11">
                {{ $t('contact.mainTitle') }}
                <span>{{ $t('contact.mainTitleSpan') }}</span>
              </p>
            </div>
            <button class="theme-btn2 cnt-clr">
              <a href="mailto:contact@opalina.com?subject=Connect with us">
                {{ $t('home.cards.contact.connectWithUs') }}
              </a>
            </button>
          </div>
        </div>
      </div>

       <div class="animation_card33" :class="{ 'animation_card5': expandedCard === 'banking' }">
              <h1>{{ $t('home.cards.banking.title') }}</h1>
              <div class="d-flex col-md-12 padding0">
                <div class="para1 col-md-6 col-sm-12">
                  <p>{{ $t('home.cards.banking.expandedDescription1') }}</p>
                  <p>{{ $t('home.cards.banking.expandedDescription2') }}</p>
                </div>
                <div class="pointer col-md-6 col-sm-12">
                  <ul class="list-style-three">
                    <li>
                      <p>
                        <span>{{ $t('home.cards.banking.stat1.number') }}</span>
                        {{ $t('home.cards.banking.stat1.text') }}
                      </p>
                    </li>
                    <li>
                      <p>
                        <span>{{ $t('home.cards.banking.stat2.number') }}</span>
                        {{ $t('home.cards.banking.stat2.text') }}
                      </p>
                    </li>
                    <li>
                      <p>
                        <span>{{ $t('home.cards.banking.stat3.number') }}</span>
                        {{ $t('home.cards.banking.stat3.text') }}
                      </p>
                    </li>
                    <li>
                      <p>
                        <span>{{ $t('home.cards.banking.stat4.number') }}</span>
                        {{ $t('home.cards.banking.stat4.text') }}
                      </p>
                    </li>
                    <li>
                      <p>
                        <span>{{ $t('home.cards.banking.stat5.number') }}</span>
                        {{ $t('home.cards.banking.stat5.text') }}
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
              <button class="collapse-btn opa-btn collapse-btn-flex22" @click.stop="collapseCard">
                <img src="/assets/images/icon/right.png">
              </button>
              <button class="collapse-btn1 collapse-btn-flex33">
                <router-link to="/enterprise-banking-services">{{ $t('home.cards.exploreMore') }}</router-link>
              </button>
            </div>


            <div class="animation_card44" :class="{ 'animation_card6': expandedCard === 'digital' }">
              <h1>{{ $t('home.cards.digital.title') }}</h1>
              <div class="d-flex col-md-12 padding0">
                <div class="para1 col-md-6">
                  <p>{{ $t('home.cards.digital.expandedDescription1') }}</p>
                  <p>{{ $t('home.cards.digital.expandedDescription2') }}</p>
                </div>
                <div class="pointer col-md-6">
                  <ul class="list-style-three">
                    <li>
                      <p>
                        <span>{{ $t('home.cards.digital.stat1.number') }}</span>
                        {{ $t('home.cards.digital.stat1.text') }}
                      </p>
                    </li>
                    <li>
                      <p>
                        <span>{{ $t('home.cards.digital.stat2.number') }}</span>
                        {{ $t('home.cards.digital.stat2.text') }}
                      </p>
                    </li>
                    <li>
                      <p>
                        <span>{{ $t('home.cards.digital.stat3.number') }}</span>
                        {{ $t('home.cards.digital.stat3.text') }}
                      </p>
                    </li>
                    <li>
                      <p>
                        <span>{{ $t('home.cards.digital.stat4.number') }}</span>
                        {{ $t('home.cards.digital.stat4.text') }}
                      </p>
                    </li>
                    <li>
                      <p>
                        <span>{{ $t('home.cards.digital.stat5.number') }}</span>
                        {{ $t('home.cards.digital.stat5.text') }}
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
              <button class="collapse-btn opa-btn collapse-btn-flex22" @click.stop="collapseCard">
                <img src="/assets/images/icon/right.png">
              </button>
              <button class="collapse-btn1 collapse-btn-flex33">
                <router-link to="/service-digital">{{ $t('home.cards.exploreMore') }}</router-link>
              </button>
            </div>


            <div class="animation_card55" :class="{ 'animation_card7': expandedCard === 'itStaffing' }">
              <h1>{{ $t('home.cards.itStaffing.title') }}</h1>
              <div class="d-flex col-md-12 padding0">
                <div class="para1 col-md-6">
                  <p>{{ $t('home.cards.itStaffing.expandedDescription1') }}</p>
                  <p>{{ $t('home.cards.itStaffing.expandedDescription2') }}</p>
                </div>
                <div class="pointer col-md-6">
                  <ul class="list-style-three">
                    <li>
                      <p>
                        <span>{{ $t('home.cards.itStaffing.stat1.number') }}</span>
                        {{ $t('home.cards.itStaffing.stat1.text') }}
                      </p>
                    </li>
                    <li>
                      <p>
                        <span>{{ $t('home.cards.itStaffing.stat2.number') }}</span>
                        {{ $t('home.cards.itStaffing.stat2.text') }}
                      </p>
                    </li>
                    <li>
                      <p>
                        <span>{{ $t('home.cards.itStaffing.stat3.number') }}</span>
                        {{ $t('home.cards.itStaffing.stat3.text') }}
                      </p>
                    </li>
                    <li>
                      <p>
                        <span>{{ $t('home.cards.itStaffing.stat4.number') }}</span>
                        {{ $t('home.cards.itStaffing.stat4.text') }}
                      </p>
                    </li>
                    <li>
                      <p>
                        <span>{{ $t('home.cards.itStaffing.stat5.number') }}</span>
                        {{ $t('home.cards.itStaffing.stat5.text') }}
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
              <button class="collapse-btn opa-btn collapse-btn-flex22" @click.stop="collapseCard">
                <img src="/assets/images/icon/right.png">
              </button>
              <button class="collapse-btn1 collapse-btn-flex33">
                <router-link to="/service-it-staff">{{ $t('home.cards.exploreMore') }}</router-link>
              </button>
            </div>
    </section>

    <!-- Banking Expertise Section -->
    <section class="featured-section bgs-cover pt-60 pb-60 " id="BankingExpertise">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-6 col-md-8 col-sm-10">
            <div class="section-title text-center mb-35">
              <h2>{{ $t('home.bankingExpertise.title') }}</h2>
            </div>
          </div>
        </div>
        <div class="row align-items-center">
          <div class="col-xl-4 col-md-6">
            <div class="feature-item wow pad-all fadeInUp delay-0-2s exp-b exp_es">
              <ul class="feature-icon">
                <router-link to="/enterprise-banking-services#RealTimePayments">
                  <li class="icon-img1">
                    <img :src="'/assets/images/icon/realtimepayment.png'" />
                  </li>
                  <li>
                    <h5>{{ $t('home.bankingExpertise.items.realTimePayments.title') }}</h5>
                    <p class="bank-exp">{{ $t('home.bankingExpertise.items.realTimePayments.description') }}</p>
                  </li>
                </router-link>
              </ul>
            </div>
          </div>
          <div class="col-xl-4 col-md-6">
            <div class="feature-item wow pad-all fadeInUp delay-0-2s exp-b exp_es">
              <ul class="feature-icon">
                <router-link to="/enterprise-banking-services#InterbankPayments">
                  <li class="icon-img1">
                    <img :src="'/assets/images/icon/interbank.png'" />
                  </li>
                  <li>
                    <h5>{{ $t('home.bankingExpertise.items.interbankPayments.title') }}</h5>
                    <p class="bank-exp">{{ $t('home.bankingExpertise.items.interbankPayments.description') }}</p>
                  </li>
                </router-link>
              </ul>
            </div>
          </div>
          <div class="col-xl-4 col-md-6">
            <div class="feature-item wow pad-all fadeInUp delay-0-2s exp-b exp_es">
              <ul class="feature-icon">
                <router-link to="/enterprise-banking-services#BankingExpertise">
                  <li class="icon-img1">
                    <img :src="'/assets/images/icon/qrpayment.png'" />
                  </li>
                  <li>
                    <h5>{{ $t('home.bankingExpertise.items.qrBasedPayments.title') }}</h5>
                    <p class="bank-exp">{{ $t('home.bankingExpertise.items.qrBasedPayments.description') }}</p>
                  </li>
                </router-link>
              </ul>
            </div>
          </div>
          <div class="col-xl-4 col-md-6">
            <div class="feature-item wow pad-all fadeInUp delay-0-2s exp-b exp_es">
              <ul class="feature-icon">
                <router-link to="/enterprise-banking-services#PaymentRoutingandWorkflows">
                  <li class="icon-img1">
                    <img :src="'/assets/images/icon/payment-routing.png'" />
                  </li>
                  <li>
                    <h5>{{ $t('home.bankingExpertise.items.paymentRouting.title') }}</h5>
                    <p class="bank-exp">{{ $t('home.bankingExpertise.items.paymentRouting.description') }}</p>
                  </li>
                </router-link>
              </ul>
            </div>
          </div>
          <div class="col-xl-4 col-md-6">
            <div class="feature-item wow pad-all fadeInUp delay-0-2s exp-b exp_es">
              <ul class="feature-icon">
                <router-link to="/enterprise-banking-services#BankingExpertise">
                  <li class="icon-img1">
                    <img :src="'/assets/images/icon/accounting.png'" />
                  </li>
                  <li>
                    <h5>{{ $t('home.bankingExpertise.items.accountingServices.title') }}</h5>
                    <p class="bank-exp">{{ $t('home.bankingExpertise.items.accountingServices.description') }}</p>
                  </li>
                </router-link>
              </ul>
            </div>
          </div>
          <div class="col-xl-4 col-md-6">
            <div class="feature-item wow pad-all fadeInUp delay-0-2s exp-b exp_es">
              <ul class="feature-icon">
                <router-link to="/enterprise-banking-services#BankingExpertise">
                  <li class="icon-img1">
                    <img :src="'/assets/images/icon/reconcil.png'" />
                  </li>
                  <li>
                    <h5>{{ $t('home.bankingExpertise.items.reconciliationServices.title') }}</h5>
                    <p class="bank-exp">{{ $t('home.bankingExpertise.items.reconciliationServices.description') }}</p>
                  </li>
                </router-link>
              </ul>
            </div>
          </div>
          <div class="col-xl-4 col-md-6">
            <div class="feature-item wow pad-all fadeInUp delay-0-2s exp-b exp_es">
              <ul class="feature-icon">
                <router-link to="/enterprise-banking-services#CorporateBankingPortal">
                  <li class="icon-img1">
                    <img :src="'/assets/images/icon/bankportal.png'" />
                  </li>
                  <li>
                    <h5>{{ $t('home.bankingExpertise.items.corporateBankingPortal.title') }}</h5>
                    <p class="bank-exp">{{ $t('home.bankingExpertise.items.corporateBankingPortal.description') }}</p>
                  </li>
                </router-link>
              </ul>
            </div>
          </div>
          <div class="col-xl-4 col-md-6">
            <div class="feature-item pad-all wow fadeInUp delay-0-2s exp-b exp_es">
              <ul class="feature-icon">
                <router-link to="/enterprise-banking-services#ComplianceandSecurity">
                  <li class="icon-img1">
                    <img :src="'/assets/images/icon/security.png'" />
                  </li>
                  <li>
                    <h5>{{ $t('home.bankingExpertise.items.complianceSecurity.title') }}</h5>
                    <p class="bank-exp">{{ $t('home.bankingExpertise.items.complianceSecurity.description') }}</p>
                  </li>
                </router-link>
              </ul>
            </div>
          </div>
          <div class="col-xl-4 col-md-6">
            <div class="feature-item pad-all wow fadeInUp delay-0-2s exp-b exp_es">
              <ul class="feature-icon">
                <router-link to="/enterprise-banking-services#BankingExpertise">
                  <li class="icon-img1">
                    <img :src="'/assets/images/icon/lending.png'" />
                  </li>
                  <li>
                    <h5>{{ $t('home.bankingExpertise.items.lendingWorkflows.title') }}</h5>
                    <p class="bank-exp">{{ $t('home.bankingExpertise.items.lendingWorkflows.description') }}</p>
                  </li>
                </router-link>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Enterprise Expertise Section -->
    <section class=" featured-section bgs-cover pt-60 pb-60 bg-color-exp" id="EnterpriseExpertise">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-6 col-md-8 col-sm-10">
            <div class="section-title text-center mb-35">
              <h2>{{ $t('home.enterpriseExpertise.title') }}</h2>
            </div>
          </div>
        </div>
        <div class="row align-items-center">
           <div class="col-xl-4 col-md-6">
            <div class="feature-item_enter wow fadeInUp delay-0-2s exp-b h-enter">
              <ul class="enterp">
                <router-link to="/enterprise-banking-services#EnterpriseArchitectureAssessmentandDevelopment">
                  <li>
                    <img :src="'/assets/images/icon/data-management.png'" />
                  </li>
                  <li>
                    <h5>{{ $t('home.enterpriseExpertise.items.dataProcessing.title') }}</h5>
                    <p class="bank-exp">{{ $t('home.enterpriseExpertise.items.dataProcessing.description') }}</p>
                  </li>
                </router-link>
              </ul>
            </div>
          </div>
           <div class="col-xl-4 col-md-6">
            <div class="feature-item_enter wow fadeInUp delay-0-2s exp-b h-enter">
              <ul class="enterp">
                <router-link to="/enterprise-banking-services#EnterpriseArchitectureAssessmentandDevelopment">
                  <li>
                    <img :src="'/assets/images/icon/crm.png'" />
                  </li>
                  <li>
                    <h5>{{ $t('home.enterpriseExpertise.items.CRMERPBusinessSolutions.title') }}</h5>
                    <p class="bank-exp">{{ $t('home.enterpriseExpertise.items.CRMERPBusinessSolutions.description') }}</p>
                  </li>
                </router-link>
              </ul>
            </div>
          </div>
           <div class="col-xl-4 col-md-6">
            <div class="feature-item_enter wow fadeInUp delay-0-2s exp-b h-enter">
              <ul class="enterp">
                <router-link to="/enterprise-banking-services#EnterpriseArchitectureAssessmentandDevelopment">
                  <li>
                    <img :src="'/assets/images/icon/data-e.png'" />
                  </li>
                  <li>
                    <h5>{{ $t('home.enterpriseExpertise.items.dataEngineering.title') }}</h5>
                    <p class="bank-exp">{{ $t('home.enterpriseExpertise.items.dataEngineering.description') }}</p>
                  </li>
                </router-link>
              </ul>
            </div>
          </div>
           <div class="col-xl-4 col-md-6">
            <div class="feature-item_enter wow fadeInUp delay-0-2s exp-b h-enter">
              <ul class="enterp">
                <router-link to="/enterprise-banking-services#EnterpriseArchitectureAssessmentandDevelopment">
                  <li>
                    <img :src="'/assets/images/icon/bi.png'" />
                  </li>
                  <li>
                    <h5>{{ $t('home.enterpriseExpertise.items.businessIntelligence.title') }}</h5>
                    <p class="bank-exp">{{ $t('home.enterpriseExpertise.items.businessIntelligence.description') }}</p>
                  </li>
                </router-link>
              </ul>
            </div>
          </div>


          <div class="col-xl-4 col-md-6">
            <div class="feature-item_enter wow fadeInUp delay-0-2s exp-b h-enter">
              <ul class="enterp">
                <router-link to="/enterprise-banking-services#EnterpriseArchitectureAssessmentandDevelopment">
                  <li>
                    <img :src="'/assets/images/icon/structure.png'" />
                  </li>
                  <li>
                    <h5>{{ $t('home.enterpriseExpertise.items.enterpriseArchitecture.title') }}</h5>
                    <p class="bank-exp">{{ $t('home.enterpriseExpertise.items.enterpriseArchitecture.description') }}</p>
                  </li>
                </router-link>
              </ul>
            </div>
          </div>
          <!-- <div class="col-xl-4 col-md-6">
            <div class="feature-item_enter wow fadeInUp delay-0-2s exp-b h-enter">
              <ul class="enterp">
                <router-link to="/enterprise-banking-services#EnterpriseExpertise">
                  <li>
                    <img :src="'/assets/images/icon/domain.png'" />
                  </li>
                  <li>
                    <h5>{{ $t('home.enterpriseExpertise.items.domainDrivenSolutioning.title') }}</h5>
                    <p class="bank-exp">{{ $t('home.enterpriseExpertise.items.domainDrivenSolutioning.description') }}</p>
                  </li>
                </router-link>
              </ul>
            </div>
          </div> -->
          <div class="col-xl-4 col-md-6">
            <div class="feature-item_enter wow fadeInUp delay-0-2s exp-b h-enter">
              <ul class="enterp">
                <router-link to="/enterprise-banking-services#EnterpriseExpertise">
                  <li>
                    <img :src="'/assets/images/icon/api.png'" />
                  </li>
                  <li>
                    <h5>{{ $t('home.enterpriseExpertise.items.microservicesApi.title') }}</h5>
                    <p class="bank-exp">{{ $t('home.enterpriseExpertise.items.microservicesApi.description') }}</p>
                  </li>
                </router-link>
              </ul>
            </div>
          </div>
          <div class="col-xl-4 col-md-6">
            <div class="feature-item_enter wow fadeInUp delay-0-2s exp-b h-enter">
              <ul class="enterp">
                <router-link to="/enterprise-banking-services#ProcessandWorkflowAutomation">
                  <li>
                    <img :src="'/assets/images/icon/workflow.png'" />
                  </li>
                  <li>
                    <h5>{{ $t('home.enterpriseExpertise.items.processWorkflowAutomation.title') }}</h5>
                    <p class="bank-exp">{{ $t('home.enterpriseExpertise.items.processWorkflowAutomation.description') }}</p>
                  </li>
                </router-link>
              </ul>
            </div>
          </div>
          <div class="col-xl-4 col-md-6">
            <div class="feature-item_enter wow fadeInUp delay-0-2s exp-b h-enter">
              <ul class="enterp">
                <router-link to="/enterprise-banking-services#LegacySystemTransformation">
                  <li>
                    <img :src="'/assets/images/icon/legacy.png'" />
                  </li>
                  <li>
                    <h5>{{ $t('home.enterpriseExpertise.items.legacyTransformation.title') }}</h5>
                    <p class="bank-exp">{{ $t('home.enterpriseExpertise.items.legacyTransformation.description') }}</p>
                  </li>
                </router-link>
              </ul>
            </div>
          </div>
          <div class="col-xl-4 col-md-6">
            <div class="feature-item_enter wow fadeInUp delay-0-2s exp-b h-enter">
              <ul class="enterp">
                <router-link to="/enterprise-banking-services#CloudMigrationServices">
                  <li>
                    <img :src="'/assets/images/icon/cloud.png'" />
                  </li>
                  <li>
                    <h5>{{ $t('home.enterpriseExpertise.items.cloudMigration.title') }}</h5>
                    <p class="bank-exp">{{ $t('home.enterpriseExpertise.items.cloudMigration.description') }}</p>
                  </li>
                </router-link>
              </ul>
            </div>
          </div>
          <!-- <div class="col-xl-4 col-md-6">
            <div class="feature-item_enter wow fadeInUp delay-0-2s exp-b h-enter">
              <ul class="enterp">
                <router-link to="/enterprise-banking-services#CentralizedEventMonitoringHub">
                  <li>
                    <img :src="'/assets/images/icon/centralized.png'" />
                  </li>
                  <li>
                    <h5>{{ $t('home.enterpriseExpertise.items.centralizedEventMonitoring.title') }}</h5>
                    <p class="bank-exp">{{ $t('home.enterpriseExpertise.items.centralizedEventMonitoring.description') }}</p>
                  </li>
                </router-link>
              </ul>
            </div>
          </div> -->
          <!-- <div class="col-xl-4 col-md-6">
            <div class="feature-item_enter wow fadeInUp delay-0-2s exp-b h-enter">
              <ul class="enterp">
                <router-link to="/enterprise-banking-services#EnterpriseExpertise">
                  <li>
                    <img :src="'/assets/images/icon/rbac_hub.png'" />
                  </li>
                  <li>
                    <h5>{{ $t('home.enterpriseExpertise.items.centralizedRbacHub.title') }}</h5>
                    <p class="bank-exp">{{ $t('home.enterpriseExpertise.items.centralizedRbacHub.description') }}</p>
                  </li>
                </router-link>
              </ul>
            </div>
          </div> -->
          <!-- <div class="col-xl-4 col-md-6">
            <div class="feature-item_enter wow fadeInUp delay-0-2s exp-b h-enter">
              <ul class="enterp">
                <router-link to="/enterprise-banking-services#EnterpriseExpertise">
                  <li>
                    <img :src="'/assets/images/icon/message.png'" />
                  </li>
                  <li>
                    <h5>{{ $t('home.enterpriseExpertise.items.highSpeedMessaging.title') }}</h5>
                    <p class="bank-exp">{{ $t('home.enterpriseExpertise.items.highSpeedMessaging.description') }}</p>
                  </li>
                </router-link>
              </ul>
            </div>
          </div> -->
        </div>
      </div>
    </section>

    <!-- Digital Services Section -->
    <section class="featured-section bgs-cover pt-60 pb-60 ">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-6 col-md-8 col-sm-10">
            <div class="section-title text-center mb-35">
              <h2>{{ $t('home.digitalServices.title') }}</h2>
            </div>
          </div>
        </div>
        <div class="col-md-12 d-flex justify-content-between p-01">
          <div class="col-md-6 digi-img disp-n"></div>
          <div class="col-md-6 align-items-center p-01">
            <div class="feature-item wow fadeInUp delay-0-2s exp-b">
              <ul class="feature-icon">
                <router-link to="/service-digital#MobileAppDevelopment">
                  <li class="icon-img1">
                    <img src="/assets/images/icon/app-d.png" />
                  </li>
                  <li>
                    <h5>{{ $t('home.digitalServices.items.mobileAppDevelopment.title') }}</h5>
                    <p class="bank-exp">{{ $t('home.digitalServices.items.mobileAppDevelopment.description') }}</p>
                  </li>
                </router-link>
              </ul>
            </div>
            <div class="feature-item wow fadeInUp delay-0-2s exp-b">
              <ul class="feature-icon">
                <router-link to="/service-digital#FrontendDevelopment">
                  <li class="icon-img1">
                    <img src="/assets/images/icon/frontend.png" />
                  </li>
                  <li>
                    <h5>{{ $t('home.digitalServices.items.frontendDevelopment.title') }}</h5>
                    <p class="bank-exp">{{ $t('home.digitalServices.items.frontendDevelopment.description') }}</p>
                  </li>
                </router-link>
              </ul>
            </div>
            <div class="feature-item wow fadeInUp delay-0-2s exp-b">
              <ul class="feature-icon">
                <router-link to="/service-digital#BackendDevelopment">
                  <li class="icon-img1">
                    <img src="/assets/images/icon/backend.png" />
                  </li>
                  <li>
                    <h5>{{ $t('home.digitalServices.items.backendDevelopment.title') }}</h5>
                    <p class="bank-exp">{{ $t('home.digitalServices.items.backendDevelopment.description') }}</p>
                  </li>
                </router-link>
              </ul>
            </div>
            <div class="feature-item wow fadeInUp delay-0-2s exp-b">
              <ul class="feature-icon">
                <router-link to="/service-digital#APIDevelopment">
                  <li class="icon-img1">
                    <img src="/assets/images/icon/api.png" />
                  </li>
                  <li>
                    <h5>{{ $t('home.digitalServices.items.apiDevelopment.title') }}</h5>
                    <p class="bank-exp">{{ $t('home.digitalServices.items.apiDevelopment.description') }}</p>
                  </li>
                </router-link>
              </ul>
            </div>
            <div class="feature-item wow fadeInUp delay-0-2s exp-b">
              <ul class="feature-icon">
                <router-link to="/service-digital#CrossPlatformAppDevelopment">
                  <li class="icon-img1">
                    <img src="/assets/images/icon/crosse-p.png" />
                  </li>
                  <li>
                    <h5>{{ $t('home.digitalServices.items.crossPlatformApp.title') }}</h5>
                    <p class="bank-exp">{{ $t('home.digitalServices.items.crossPlatformApp.description') }}</p>
                  </li>
                </router-link>
              </ul>
            </div>
            <div class="feature-item wow fadeInUp delay-0-2s exp-b">
              <ul class="feature-icon">
                <router-link to="/service-digital#DigitalAssetManagement">
                  <li class="icon-img1">
                    <img src="/assets/images/icon/dam.png" />
                  </li>
                  <li>
                    <h5>{{ $t('home.digitalServices.items.digitalAssetManagement.title') }}</h5>
                    <p class="bank-exp">{{ $t('home.digitalServices.items.digitalAssetManagement.description') }}</p>
                  </li>
                </router-link>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Key Elements Section -->
    <section class="who-we-are overlay text-white text-center pt-50 pb-50 rpb-20">
      <div class="container">
        <div class="section-title">
          <h2>{{ $t('home.keyElements.title') }}</h2>
        </div>
        <div class="row">
          <div class="col-xl-3 col-md-6">
            <div class="service-item-five wow fadeInUp delay-0-2s">
              <div class="service-content-five min-h">
                <div class="icon service-i">
                  <img src="/assets/images/icon/domain.png" />
                </div>
                <h3 class="pt-4">{{ $t('home.keyElements.items.domainExpertise.title') }}</h3>
                <p>{{ $t('home.keyElements.items.domainExpertise.description') }}</p>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-md-6">
            <div class="service-item-five wow fadeInUp delay-0-4s">
              <div class="service-content-five min-h">
                <div class="icon service-i">
                  <img src="/assets/images/icon/three.png" />
                </div>
                <h3 class="pt-4">{{ $t('home.keyElements.items.approach360.title') }}</h3>
                <p>{{ $t('home.keyElements.items.approach360.description') }}</p>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-md-6">
            <div class="service-item-five wow fadeInUp delay-0-6s">
              <div class="service-content-five min-h">
                <div class="icon service-i">
                  <img src="/assets/images/icon/agile.png" />
                </div>
                <h3 class="pt-4">{{ $t('home.keyElements.items.agility.title') }}</h3>
                <p>{{ $t('home.keyElements.items.agility.description') }}</p>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-md-6">
            <div class="service-item-five wow fadeInUp delay-0-8s">
              <div class="service-content-five min-h">
                <div class="icon service-i">
                  <img src="/assets/images/icon/enterprise.png" />
                </div>
                <h3 class="pt-4">{{ $t('home.keyElements.items.enterpriseThinking.title') }}</h3>
                <p>{{ $t('home.keyElements.items.enterpriseThinking.description') }}</p>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-md-6">
            <div class="service-item-five wow fadeInUp delay-0-8s">
              <div class="service-content-five min-h">
                <div class="icon service-i">
                  <img src="/assets/images/icon/performance.png" />
                </div>
                <h3 class="pt-4">{{ $t('home.keyElements.items.performanceOriented.title') }}</h3>
                <p>{{ $t('home.keyElements.items.performanceOriented.description') }}</p>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-md-6">
            <div class="service-item-five wow fadeInUp delay-0-8s">
              <div class="service-content-five min-h">
                <div class="icon service-i">
                  <img src="/assets/images/icon/puzzle.png" />
                </div>
                <h3 class="pt-4">{{ $t('home.keyElements.items.tailoredSolutions.title') }}</h3>
                <p>{{ $t('home.keyElements.items.tailoredSolutions.description') }}</p>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-md-6">
            <div class="service-item-five wow fadeInUp delay-0-8s">
              <div class="service-content-five min-h">
                <div class="icon service-i">
                  <img src="/assets/images/icon/technology.png" />
                </div>
                <h3 class="pt-4">{{ $t('home.keyElements.items.innovativeTechnologies.title') }}</h3>
                <p>{{ $t('home.keyElements.items.innovativeTechnologies.description') }}</p>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-md-6">
            <div class="service-item-five wow fadeInUp delay-0-8s">
              <div class="service-content-five min-h">
                <div class="icon service-i">
                  <img src="/assets/images/icon/global.png" />
                </div>
                <h3 class="pt-4">{{ $t('home.keyElements.items.globalExpertise.title') }}</h3>
                <p>{{ $t('home.keyElements.items.globalExpertise.description') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Why Work With Us Section -->
    <section class="why_m_t">
      <div class="container">
        <div class="row align-items-end">
          <div class="col-sm-6">
            <h1 class="why-h">{{ $t('home.whyWorkWithUs.title') }}</h1>
          </div>
          <div class="col-sm-6 ent pb-20">
            <p>{{ $t('home.whyWorkWithUs.description') }}</p>
          </div>
        </div>

        <div data-bs-spy="scroll" data-bs-target=".custom_navbar" data-bs-offset="50">
          <div class="">
            <div class="row">
              <div class="col-sm-6 disp-n">
                <ul class="navbar-nav custom_navbar">
                  <li class="nav-item">
                    <a class="nav-link" href="#section1">
                      <img src="/assets/images/about/digi1.png" alt="" />
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="#section2">
                      <img src="/assets/images/about/digi2.png" alt="" />
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="#section3">
                      <img src="/assets/images/about/digi3.png" alt="" />
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="#section4">
                      <img src="/assets/images/about/digi4.png" alt="" />
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="#section5">
                      <img src="/assets/images/about/digi5.png" alt="" />
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="#section6">
                      <img src="/assets/images/about/digi6.png" alt="" />
                    </a>
                  </li>
                </ul>
              </div>

              <div class="col-sm-6">
                <div id="section1" class="container-fluid text-white why-us col-pad-hgt">
                  <h1>{{ $t('home.whyWorkWithUs.items.specializedExpertise.title') }}</h1>
                  <p>{{ $t('home.whyWorkWithUs.items.specializedExpertise.description') }}</p>
                </div>

                <div id="section2" class="container-fluid why-us col-pad-hgt">
                  <h1>{{ $t('home.whyWorkWithUs.items.flexibility.title') }}</h1>
                  <p>{{ $t('home.whyWorkWithUs.items.flexibility.description') }}</p>
                </div>

                <div id="section3" class="container-fluid text-white why-us col-pad-hgt">
                  <h1>{{ $t('home.whyWorkWithUs.items.personalizedService.title') }}</h1>
                  <p>{{ $t('home.whyWorkWithUs.items.personalizedService.description') }}</p>
                </div>

                <div id="section4" class="container-fluid text-white why-us col-pad-hgt">
                  <h1>{{ $t('home.whyWorkWithUs.items.innovation.title') }}</h1>
                  <p>{{ $t('home.whyWorkWithUs.items.innovation.description') }}</p>
                </div>

                <div id="section5" class="container-fluid text-white why-us col-pad-hgt">
                  <h1>{{ $t('home.whyWorkWithUs.items.costEffective.title') }}</h1>
                  <p>{{ $t('home.whyWorkWithUs.items.costEffective.description') }}</p>
                </div>

                <div id="section6" class="container-fluid text-white why-us col-pad-hgt">
                  <h1>{{ $t('home.whyWorkWithUs.items.commitment.title') }}</h1>
                  <p>{{ $t('home.whyWorkWithUs.items.commitment.description') }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Global Success Section -->
    <section class="fact-counter-section z-1 pos-rel bg-white">
      <div class="container">
        <div class="fact-counter-inner text-white" :style="{ backgroundImage: 'url(/assets/images/counter/counter-bg-section.jpg)' }">
          <div class="row align-items-center">
            <div class="col-lg-6">
              <div class="counter-left-content px-100 py-70 wow fadeInLeft delay-0-2s counter-p">
                <div class="section-title mb-20">
                  <h2>{{ $t('home.globalSuccess.title') }}</h2>
                </div>
                <p>{{ $t('home.globalSuccess.description') }}</p>
              </div>
            </div>
            <div class="col-lg-6 map-width ">
              <img src="/assets/images/services/map111.png" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Newsletter/Contact Section -->
    <section class="testimonial-section pt-20 pb-100 rpb-20 testi1">
      <div class="container">
        <div class="section-title text-center newsletter">
          <h2>{{ $t('contact.title') }} <span>{{ $t('contact.titleSpan') }}</span></h2>
          <!-- <h2>
           
          </h2> -->
          <button>
            <a href="mailto:contact@opalina.com?subject=Connect with us">
              <h3>{{ $t('contact.emailAddress') }}</h3>
            </a>
          </button>
        </div>
      </div>
    </section>

    <!-- Floating Mail Button -->
    <div>
      <a href="mailto:contact@opalina.com?subject=Connect with us">
        <button class="bot">
          <img src="/assets/images/services/mail-f.png" />
        </button>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      expandedCard: null
    }
  },
  mounted() {
    // Initialize animations and effects
    this.$nextTick(() => {
      // WOW.js animations
      if (typeof WOW !== 'undefined') {
        new WOW().init()
      }
      
      // Text flip animation for English
      if (this.$i18n.locale === 'en') {
        this.initTextFlip()
      }

      // Initialize Bootstrap 5 scrollspy
      this.initScrollSpy()
    })
  },
  watch: {
    '$i18n.locale'(newLocale) {
      // Reinitialize animations when language changes
      this.$nextTick(() => {
        if (newLocale === 'en') {
          this.initTextFlip()
        }
      })
    }
  },
  methods: {
    expandCard(cardType) {
      // Simple toggle behavior like in PHP version
      if (this.expandedCard === cardType) {
        this.expandedCard = null
      } else {
        this.expandedCard = cardType
      }
    },
    collapseCard() {
      this.expandedCard = null
    },
    initTextFlip() {
      // Text flip animation logic
      const flip = document.getElementById('flip')
      if (flip) {
        // Add flip animation classes
        flip.classList.add('flip-active')
      }
    },
    initScrollSpy() {
      // Initialize Bootstrap 5 scrollspy
      if (typeof bootstrap !== 'undefined') {
        const scrollSpyEl = document.querySelector('[data-bs-spy="scroll"]')
        if (scrollSpyEl) {
          new bootstrap.ScrollSpy(scrollSpyEl, {
            target: '.custom_navbar',
            offset: 50,
            smoothScroll: true
          })
        }
      } else {
        // Fallback: manually handle scrollspy
        this.initManualScrollSpy()
      }
    },
    initManualScrollSpy() {
      // Manual scrollspy implementation
      const sections = document.querySelectorAll('.why-us[id]')
      const navLinks = document.querySelectorAll('.custom_navbar .nav-link')
      
      const handleScroll = () => {
        let currentSection = ''
        sections.forEach(section => {
          const rect = section.getBoundingClientRect()
          if (rect.top <= 100 && rect.bottom >= 100) {
            currentSection = section.id
          }
        })
        
        navLinks.forEach(link => {
          link.classList.remove('active')
          if (link.getAttribute('href') === `#${currentSection}`) {
            link.classList.add('active')
          }
        })
      }
      
      window.addEventListener('scroll', handleScroll)
      handleScroll() // Initial call
    }
  }
}
</script>

<style scoped>
/* Fix for Spanish flip animation text */
#flip-text {
  min-width: 300px !important;
  display: inline-block !important;
  text-align: center !important;
  position: relative !important;
  left: -25px !important;
}

#flip div div {
  white-space: nowrap !important;
  overflow: visible !important;
  text-overflow: unset !important;
  padding: 0 25px !important;
  width: 100% !important;
  min-width: 280px !important;
}

/* Ensure flip animation container accommodates Spanish text */
@media (max-width: 768px) {
  #flip-text {
    min-width: 240px !important;
    font-size: 14px !important;
    left: -20px !important;
  }
  
  #flip div div {
    min-width: 220px !important;
    padding: 0 20px !important;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  #flip-text {
    min-width: 270px !important;
    left: -23px !important;
  }
  
  #flip div div {
    min-width: 250px !important;
  }
}

/* Spanish-specific text styling for tagline */
.spanish-tagline {
  position: absolute !important;
  bottom: 50px !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  width: 100% !important;
  max-width: 800px !important;
  padding: 0 20px !important;
  text-align: center !important;
}

.english-tagline {
  position: absolute !important;
  bottom: 50px !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  width: 100% !important;
  max-width: 800px !important;
  padding: 0 20px !important;
  text-align: center !important;
}

.mobile-tagline {
  position: absolute !important;
  bottom: 30px !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  width: 100% !important;
  max-width: 90% !important;
  padding: 0 15px !important;
  text-align: center !important;
}

/* Text styling */
.spanish-tagline p,
.english-tagline p,
.mobile-tagline p {
  word-spacing: normal !important;
  letter-spacing: normal !important;
  white-space: nowrap !important;
  word-break: keep-all !important;
  margin: 0 !important;
  line-height: 1.4 !important;
  overflow: visible !important;
}

/* Media queries for better responsiveness */
@media (max-width: 768px) {
  .mobile-tagline {
    bottom: 20px !important;
  }
  
  .mobile-tagline p {
    font-size: 14px !important;
    line-height: 1.3 !important;
    white-space: normal !important;
  }
  
  .spanish-tagline,
  .english-tagline {
    bottom: 20px !important;
    max-width: 95% !important;
  }
  
  .spanish-tagline p,
  .english-tagline p {
    font-size: 14px !important;
    line-height: 1.3 !important;
    white-space: normal !important;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .spanish-tagline,
  .english-tagline {
    max-width: 85% !important;
  }
  
  .spanish-tagline p,
  .english-tagline p {
    font-size: 15px !important;
    line-height: 1.4 !important;
  }
}

@media (min-width: 1025px) {
  .spanish-tagline,
  .english-tagline {
    max-width: 700px !important;
  }
  
  .spanish-tagline p,
  .english-tagline p {
    font-size: 16px !important;
    line-height: 1.4 !important;
  }
}
</style>